(function () {
  function initPressQuotes(section) {
    if (!section || section.dataset.pressQuotesInit === 'true') return;
    section.dataset.pressQuotesInit = 'true';

    var tabs = Array.from(section.querySelectorAll('[data-press-quote-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-press-quote-panel]'));
    var logos = section.querySelector('.press-quotes__logos');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!tabs.length) return;

    function arrangeTabsAround(activeIndex) {
      if (!logos || tabs.length < 2) return;
      var itemsBeforeActive = Math.floor((tabs.length - 1) / 2);

      for (var offset = -itemsBeforeActive; offset < tabs.length - itemsBeforeActive; offset += 1) {
        var tabIndex = (activeIndex + offset + tabs.length) % tabs.length;
        logos.appendChild(tabs[tabIndex]);
      }
    }

    function centerTab(tab, behavior) {
      if (!logos || !tab) return;
      var tabRect = tab.getBoundingClientRect();
      var logosRect = logos.getBoundingClientRect();
      var left = logos.scrollLeft + (tabRect.left - logosRect.left) - (logos.clientWidth - tabRect.width) / 2;
      logos.scrollTo({ left: left, behavior: prefersReducedMotion ? 'auto' : behavior });
    }

    function activateQuote(blockId, moveFocus, behavior) {
      var activeIndex = tabs.findIndex(function (tab) {
        return tab.dataset.pressQuoteTab === blockId;
      });

      if (activeIndex < 0) return;
      arrangeTabsAround(activeIndex);

      tabs.forEach(function (tab) {
        var active = tab.dataset.pressQuoteTab === blockId;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;

        if (active) {
          if (moveFocus) tab.focus();
          window.requestAnimationFrame(function () {
            centerTab(tab, behavior || 'smooth');
          });
        }
      });

      panels.forEach(function (panel) {
        var active = panel.dataset.pressQuotePanel === blockId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateQuote(tab.dataset.pressQuoteTab, false, 'smooth');
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        activateQuote(tabs[nextIndex].dataset.pressQuoteTab, true, 'smooth');
      });
    });

    var initialTab = tabs.find(function (tab) {
      return tab.classList.contains('is-active');
    }) || tabs[0];
    activateQuote(initialTab.dataset.pressQuoteTab, false, 'auto');

    window.addEventListener('resize', function () {
      var activeTab = tabs.find(function (tab) {
        return tab.classList.contains('is-active');
      });
      centerTab(activeTab, 'auto');
    }, { passive: true });
  }

  function initAllPressQuotes() {
    document.querySelectorAll('[data-press-quotes]').forEach(initPressQuotes);
  }

  document.addEventListener('DOMContentLoaded', initAllPressQuotes);
  document.addEventListener('shopify:section:load', function (event) {
    initPressQuotes(event.target.querySelector('[data-press-quotes]'));
  });
})();
